export const FETCH_OPEN_ORDER_FAILURE = 'FETCH_OPEN_ORDER_FAILURE';
export const FETCH_OPEN_ORDER_REQUEST = 'FETCH_OPEN_ORDER_REQUEST';
export const FETCH_OPEN_ORDER_SUCCESS = 'FETCH_OPEN_ORDER_SUCCESS';

export const FETCH_CANCEL_ORDER_FAILURE = 'FETCH_CANCEL_ORDER_FAILURE';
export const FETCH_CANCEL_ORDER_REQUEST = 'FETCH_CANCEL_ORDER_REQUEST';
export const FETCH_CANCEL_ORDER_SUCCESS = 'FETCH_CANCEL_SUCCESS';

export const FETCH_UPDATE_ORDER_FAILURE = 'FETCH_UPDATE_ORDER_FAILURE';
export const FETCH_UPDATE_ORDER_REQUEST = 'FETCH_UPDATE_ORDER_REQUEST';
export const FETCH_UPDATE_ORDER_SUCCESS = 'FETCH_UPDATE_ORDER_SUCCESS';

export const FETCH_MATCH_DATA_FAILURE = 'FETCH_MATCH_DATA_FAILURE';
export const FETCH_MATCH_DATA_REQUEST = 'FETCH_MATCH_DATA_REQUEST';
export const FETCH_MATCH_DATA_SUCCESS = 'FETCH_MATCH_DATA_SUCCESS';

export const FETCH_ORDER_FAILURE = 'FETCH_ORDER_FAILURE';
export const FETCH_ORDER_REQUEST = 'FETCH_ORDER_REQUEST';
export const FETCH_ORDER_SUCCESS = 'FETCH_ORDER_SUCCESS';